<template>
	<div
		class="gallery relative md:absolute left-0 top-0 z-100 mt-0 flex overflow-hidden rounded-lg transition-all duration-300"
		:class="{
			'gallery-max-width': isGalleryFullScreen,
		}"
		:style="{
			width: isGalleryFullScreen ? '' : minimizedWidth,
			height: isGalleryFullScreen ? maximizedHeight : minimizedHeight,
		}"
	>
		<div
			v-if="images.length > 1"
			class="absolute top-1/2 right-1.5 z-200 flex items-center justify-end w-full -translate-y-1/2 self-center"
		>
			<button
				@click="nextSlide"
				class="btn-default shadow-xl cursor-pointer aspect-square grid place-items-center rounded-lg w-8 h-8"
			>
				<img src="/images/icons/arrow-forward.svg" alt="arrow right" class="h-4.5" />
			</button>
		</div>
		<div
			id="slides"
			class="absolute flex h-full w-full transition-all duration-300"
			:style="{
				transform: `translateX(-${currentSlide * 100}%)`,
			}"
		>
			<img
				v-for="img in images"
				:src="img"
				:alt="img"
				:key="img"
				class="w-full shrink-0 object-cover"
			/>
		</div>
		<button
			v-if="canFullScreen && images && images.length > 0 && !(images.length === 1 && images[0] === '/images/layout/placeholder.jpeg')"
			@click="toggleFullScreenGallery"
			class="absolute w-8 h-8 right-1.5 bottom-1.5 cursor-pointer transition-all duration-200 btn-default aspect-square grid place-items-center rounded-lg shadow-xl"
		>
			<ArrowsPointingOutIcon
				v-if="!isGalleryFullScreen"
				class="h-4.5 transition-all duration-200 hover:text-blue"
			/>
			<ArrowsPointingInIcon
				v-else
				class="h-4.5 transition-all duration-200 hover:text-blue"
			/>
		</button>
	</div>
</template>

<script src="./ImageGallery.js"></script>

